module.exports = __webpack_public_path__ + "static/IMG_4689-fs8-fs8-bb5a1f8bc4f9cfaf1cbd36f1d2045d45.png";